
import moment from 'moment';

export default function (scope, elm, attrs, ctrl) {
	var dateFormat = attrs.dateFormat;

	attrs.$observe('dateFormat', function (newValue) {
		if (dateFormat === newValue || !ctrl.$modelValue) return;
		dateFormat = newValue;
		ctrl.$modelValue = new Date(ctrl.$setViewValue);
	});

	ctrl.$formatters.unshift(function (modelValue) {
		if (!dateFormat || !modelValue) return "";
		var retVal = moment(modelValue).format(dateFormat);
		return retVal;
	});

	ctrl.$parsers.unshift(function (viewValue) {
		var date = moment(viewValue, dateFormat);
		return (date && date.isValid() && date.year() > 1950 ) ? date.toDate() : "";
	});
};



// WEBPACK FOOTER //
// ./src/directive/date-format/date-format.link.js